<template>
  <layout-header></layout-header>
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row">
          <!-- Booking -->
          <div class="col-lg-12">
            <!-- Booking Step -->
            <ul class="step-register row">
              <li class="activate col-md-4">
                <div class="multi-step-icon">
                  <span
                    ><img src="@/assets/img/icons/calendar-icon.svg" alt="img"
                  /></span>
                </div>
                <div class="multi-step-info">
                  <h6>Appointment</h6>
                  <p>Choose time & date for the service</p>
                </div>
              </li>
              <li class="activate col-md-4">
                <div class="multi-step-icon">
                  <span><img src="@/assets/img/icons/wallet-icon.svg" alt="img" /></span>
                </div>
                <div class="multi-step-info">
                  <h6>Payment</h6>
                  <p>Select Payment Gateway</p>
                </div>
              </li>
              <li class="active col-md-4">
                <div class="multi-step-icon">
                  <span><img src="@/assets/img/icons/book-done.svg" alt="img" /></span>
                </div>
                <div class="multi-step-info">
                  <h6>Done</h6>
                  <p>Completion of Booking</p>
                </div>
              </li>
            </ul>
            <!-- /Booking Step -->

            <!-- Booking Done -->
            <div class="row align-items-center">
              <div class="col-md-5">
                <div class="booking-done">
                  <img
                    src="@/assets/img/payment-success.svg"
                    class="img-fluid"
                    alt="image"
                  />
                </div>
              </div>
              <div class="col-md-7">
                <div class="booking-done">
                  <h6>Successfully Completed Payment</h6>
                  <p>Your Booking has been Successfully Competed</p>
                  <div class="book-submit">
                    <router-link to="/home/" class="btn btn-dark"
                      ><i class="feather-arrow-left-circle"></i> Go to Home</router-link
                    >
                    <router-link to="/booking/invoice" class="btn btn-light"
                      >Booking History</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- /Booking Done -->
          </div>
          <!-- /Booking -->
        </div>
      </div>
    </div>
  </div>
  <pages-footer></pages-footer>
</template>
